// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiSet from "lumi-rescript/lib/es6/src/LumiSet.res.js";
import * as Belt_Set from "@rescript/runtime/lib/es6/Belt_Set.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Schema$LumiStore from "lumi-store/lib/es6/src/Schema.res.js";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Types$LumiWaylight from "lumi-waylight/lib/es6/src/Types.res.js";
import * as Types$LumiDocuments from "./Types.res.js";
import * as Zigbee$LumiDocuments from "./Types/Zigbee.res.js";
import * as SensorGroups$LumiStaticData from "lumi-static-data/lib/es6/src/SensorGroups.res.js";

let options = [
  "LumicamIndicatorBol",
  "LumicamIndicatorEntree"
];

let jsonCodec = LumiJzon.anySumAsString(options, undefined);

let LumicamIndicatorType = {
  options: options,
  jsonCodec: jsonCodec
};

let jsonCodec$1 = Jzon.object1(param => param.indicatorAddress, indicatorAddress => ({
  TAG: "Ok",
  _0: {
    indicatorAddress: indicatorAddress
  }
}), Jzon.field("indicatorAddress", Types$LumiWaylight.Address.jsonCodec));

let Waylight = {
  jsonCodec: jsonCodec$1
};

let jsonCodec$2 = Jzon.object1(param => param.address, address => ({
  TAG: "Ok",
  _0: {
    address: address
  }
}), Jzon.field("address", Zigbee$LumiDocuments.Address.jsonCodec));

let ZigbeeIndicatorType = {
  jsonCodec: jsonCodec$2
};

let indicatorTypeLumicamCodec = LumiJzon.tuple2(jsonCodec, Document$LumiStore.Key.jsonCodec());

let jsonCodec$3 = LumiJzon.taggedVariant(value => {
  switch (value.TAG) {
    case "IndicatorTypeLumicam" :
      return [
        "IndicatorTypeLumicam",
        Jzon.encodeWith([
          value._0,
          value._1
        ], indicatorTypeLumicamCodec)
      ];
    case "IndicatorTypeWaylight" :
      return [
        "IndicatorTypeWaylight",
        Jzon.encodeWith(value._0, jsonCodec$1)
      ];
    case "IndicatorTypeZigbee" :
      return [
        "IndicatorTypeZigbee",
        Jzon.encodeWith(value._0, jsonCodec$2)
      ];
  }
}, param => {
  let contents = param[1];
  let tag = param[0];
  switch (tag) {
    case "IndicatorTypeLumicam" :
      return Stdlib_Result.map(Jzon.decodeWith(contents, indicatorTypeLumicamCodec), param => ({
        TAG: "IndicatorTypeLumicam",
        _0: param[0],
        _1: param[1]
      }));
    case "IndicatorTypeWaylight" :
      return Stdlib_Result.map(Jzon.decodeWith(contents, jsonCodec$1), x => ({
        TAG: "IndicatorTypeWaylight",
        _0: x
      }));
    case "IndicatorTypeZigbee" :
      return Stdlib_Result.map(Jzon.decodeWith(contents, jsonCodec$2), x => ({
        TAG: "IndicatorTypeZigbee",
        _0: x
      }));
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            tag
          ]
        }
      };
  }
}, undefined, undefined);

let IndicatorType = {
  jsonCodec: jsonCodec$3
};

let jsonCodec$4 = Jzon.object3(param => [
  param.free,
  param.busy,
  param.full
], param => ({
  TAG: "Ok",
  _0: {
    free: param[0],
    busy: param[1],
    full: param[2]
  }
}), Jzon.field("free", Types$LumiDocuments.Color.jsonCodec), Jzon.field("busy", Types$LumiDocuments.Color.jsonCodec), Jzon.field("full", Types$LumiDocuments.Color.jsonCodec));

let default_free = Types$LumiDocuments.Color.green;

let default_busy = Types$LumiDocuments.Color.orange;

let default_full = Types$LumiDocuments.Color.red;

let $$default = {
  free: default_free,
  busy: default_busy,
  full: default_full
};

let GroupOccupancyColors = {
  jsonCodec: jsonCodec$4,
  $$default: $$default
};

function freeColor(mode) {
  if (mode.TAG !== "IndicatorModeGroupOccupancy") {
    return mode._0;
  }
  let match = mode._0;
  if (match !== undefined) {
    return match.free;
  } else {
    return default_free;
  }
}

function busyColor(mode) {
  if (mode.TAG !== "IndicatorModeGroupOccupancy") {
    return mode._0;
  }
  let match = mode._0;
  if (match !== undefined) {
    return match.busy;
  } else {
    return default_busy;
  }
}

function fullColor(mode) {
  if (mode.TAG !== "IndicatorModeGroupOccupancy") {
    return mode._0;
  }
  let match = mode._0;
  if (match !== undefined) {
    return match.full;
  } else {
    return default_full;
  }
}

let jsonCodec$5 = LumiJzon.taggedVariant(value => {
  if (value.TAG === "IndicatorModeGroupOccupancy") {
    return [
      "IndicatorModeGroupOccupancy",
      Jzon.encodeWith(value._0, Jzon.nullable(jsonCodec$4))
    ];
  } else {
    return [
      "IndicatorModeSingleColor",
      Jzon.encodeWith(value._0, Types$LumiDocuments.Color.jsonCodec)
    ];
  }
}, param => {
  let contents = param[1];
  let tag = param[0];
  switch (tag) {
    case "IndicatorModeGroupOccupancy" :
      return Stdlib_Result.map(Jzon.decodeWith(contents, Jzon.nullable(jsonCodec$4)), goc => ({
        TAG: "IndicatorModeGroupOccupancy",
        _0: goc
      }));
    case "IndicatorModeSingleColor" :
      return Stdlib_Result.map(Jzon.decodeWith(contents, Types$LumiDocuments.Color.jsonCodec), color => ({
        TAG: "IndicatorModeSingleColor",
        _0: color
      }));
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            tag
          ]
        }
      };
  }
}, undefined, undefined);

let IndicatorMode = {
  freeColor: freeColor,
  busyColor: busyColor,
  fullColor: fullColor,
  jsonCodec: jsonCodec$5
};

let jsonCodec$6 = LumiJzon.taggedVariantOptionalContents(v => {
  if (typeof v !== "object") {
    if (v === "IndicatorPlanned") {
      return [
        "IndicatorPlanned",
        undefined
      ];
    } else {
      return [
        "IndicatorOperational",
        undefined
      ];
    }
  } else {
    return [
      "IndicatorMalfunction",
      Jzon.encodeWith(v._0, Jzon.string)
    ];
  }
}, pair => {
  let other = pair[0];
  switch (other) {
    case "IndicatorMalfunction" :
      let json = pair[1];
      if (json !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(json, Jzon.string), x => ({
          TAG: "IndicatorMalfunction",
          _0: x
        }));
      } else {
        return {
          TAG: "Error",
          _0: {
            NAME: "UnexpectedJsonValue",
            VAL: [
              [],
              other
            ]
          }
        };
      }
    case "IndicatorOperational" :
      return {
        TAG: "Ok",
        _0: "IndicatorOperational"
      };
    case "IndicatorPlanned" :
      return {
        TAG: "Ok",
        _0: "IndicatorPlanned"
      };
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            other
          ]
        }
      };
  }
}, undefined, undefined);

let IndicatorOperationalState = {
  jsonCodec: jsonCodec$6
};

function inputGroupSet(indicator) {
  return Stdlib_Option.mapOr(indicator.centralGroupId, Belt_Set.make(SensorGroups$LumiStaticData.GroupFullId.Cmp), gfid => LumiSet.singleton(gfid, SensorGroups$LumiStaticData.GroupFullId.Cmp));
}

let jsonCodec$7 = Jzon.object6(param => [
  param.name,
  param.notes,
  param.type_,
  param.centralGroupId,
  param.mode,
  param.operationalState
], param => ({
  TAG: "Ok",
  _0: {
    name: param[0],
    notes: param[1],
    type_: param[2],
    centralGroupId: param[3],
    mode: param[4],
    operationalState: param[5]
  }
}), Jzon.field("name", Jzon.string), Jzon.field("notes", Jzon.string), Jzon.field("type", jsonCodec$3), Jzon.field("centralGroupId", Jzon.nullable(SensorGroups$LumiStaticData.GroupFullId.jsonCodec)), Jzon.field("mode", jsonCodec$5), Jzon.field("operationalState", jsonCodec$6));

let Indicator = {
  inputGroupSet: inputGroupSet,
  jsonCodec: jsonCodec$7
};

function documentName(param) {
  return param.name;
}

let Schema = Schema$LumiStore.Make({
  documentName: documentName,
  tag: "indicator",
  jsonCodec: jsonCodec$7,
  icon: "traffic-light",
  readOnly: false
});

let GroupFullId;

export {
  GroupFullId,
  LumicamIndicatorType,
  Waylight,
  ZigbeeIndicatorType,
  IndicatorType,
  GroupOccupancyColors,
  IndicatorMode,
  IndicatorOperationalState,
  Indicator,
  Schema,
}
/* jsonCodec Not a pure module */
